var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.418,
    height: 18.88,
    viewBox: "0 0 14.418 18.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notification",
    d: "M314.856,656.62h-.515v-7.3a6.005,6.005,0,0,0-5.148-5.945v-.835a.859.859,0,0,0-1.717,0v.835a6.005,6.005,0,0,0-5.148,5.945v7.3h-.515a.686.686,0,0,0-.687.687v.687a.172.172,0,0,0,.171.172h4.635a2.4,2.4,0,0,0,4.806,0h4.635a.172.172,0,0,0,.171-.172v-.687A.686.686,0,0,0,314.856,656.62Zm-6.522,2.574a1.029,1.029,0,0,1-1.03-1.029h2.06A1.029,1.029,0,0,1,308.334,659.195Zm-4.463-2.574v-7.3a4.463,4.463,0,1,1,8.925,0v7.3Z",
    transform: "translate(-301.125 -641.688)",
    fill: "#0f0f0f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6350574d4ad6345f35bddd28ccd20ec5.svg";
export { ForwardRef as ReactComponent };